import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { ThreeDotsIcon } from '../../assets/icons/index';
import { Popover } from './popover';
import { PopoverClose } from './popover-close';
import { PopoverContent } from './popover-content';
import { PopoverTrigger } from './popover-trigger';

export type PopoverWrapperProps = Optional<
  { children: ReactNode },
  {
    items: {
      className?: string;
      condition?: boolean;
      icon: ReactNode;
      onClick: () => void;
      text: string;
    }[];
  }
>;

export type PopoverWrapperItemProps = {
  className?: string;
  onClick: () => void;
} & Optional<
  {
    children: ReactNode;
  },
  { icon: ReactNode; text: string }
>;

export const PopoverWrapperItem: FC<PopoverWrapperItemProps> = ({
  children,
  onClick,
  className,
  icon,
  text,
}) => (
  <div
    className={twMerge(
      'flex w-full items-center gap-2 p-[6px] pr-8 text-sm font-normal text-gray-700 hover:bg-gray-50',
      className,
    )}
    onClick={onClick}
  >
    {icon}
    {text}
    {children}
  </div>
);

export const PopoverWrapper: FC<PopoverWrapperProps> = ({ children, items }) => (
  <Popover>
    <PopoverTrigger className="h-fit w-fit rounded data-[state=open]:shadow-md">
      <div className="flex size-6 rotate-90 items-center justify-center rounded bg-transparent transition-colors hover:bg-gray-100">
        <ThreeDotsIcon />
      </div>
    </PopoverTrigger>
    <PopoverContent className="flex w-fit flex-col gap-[2px] rounded p-2 font-normal shadow-2xl">
      <PopoverClose>
        {items
          ? items.map(
              ({ condition = true, ...item }, i) =>
                condition && <PopoverWrapperItem {...item} key={`${i}_${new Date().getTime()}`} />,
            )
          : children}
      </PopoverClose>
    </PopoverContent>
  </Popover>
);
